import { PlusIcon } from '@heroicons/react/24/solid';
import React, { FunctionComponent, useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import DashboardNav from '../../components/dashboard-nav/DashboardNav';
import LoadingSpinner from '../../components/loading-spinner/LoadingSpinner';
import { useBriefsOverview } from '../../hooks/useBriefs';
import { useAccount } from '../../hooks/useAccount';
import DashboardPageLayout from '../../layouts/dashboard/dashboardPageLayout';
import { closeSidebar } from '../../state/app-state';

const AddNewBriefRoute = '/dashboard/brief/new';

const HomePage: FunctionComponent = () => {
  const history = useHistory();

  const { account: currentAccount } = useAccount();
  const account = currentAccount!;
  const { briefs: briefItems, loading: isFetchingBriefs } = useBriefsOverview();
  const briefs = { items: briefItems }; // render-only

  useEffect(() => {
    if (isFetchingBriefs) {
      closeSidebar();
    }
  }, [isFetchingBriefs]);

  const isLoading = () => {
    return !!isFetchingBriefs;
  };

  // const activeAccount = account?.subscription?.active;

  // TODO(Jose): Temp redirection until we improve our home UX
  if (account.metadata?.isTwitterUser) return <Redirect to="/dashboard/social" />;

  if (briefs && briefs.items && briefs.items.length > 0) {
    return <Redirect to={`/dashboard/brief/${briefs.items[0].id}`} />;
  }

  if (account.metadata?.totalReportsCount === 0 && !account.metadata?.isTwitterUser) {
    return <Redirect to="/dashboard/onboarding/new-report" />;
  }

  if (isLoading()) {
    return <LoadingSpinner />;
  }

  return (
    <DashboardPageLayout>
      <DashboardNav>
        <div className="flex-1 flex">
          <h1 className="text-lg font-bold m-0 text-gray-900 sm:truncate">Home</h1>
        </div>
        <div className="flex ml-4">
          <button
            type="button"
            className="order-0 inline-flex items-center px-4 py-2 border border-transparent shadow-xs text-sm font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 sm:order-1 sm:ml-3"
            onClick={() => {
              history.push(AddNewBriefRoute);
            }}
          >
            <PlusIcon className="-ml-1 mr-2 h-5 w-5" aria-hidden="true" />
            New Brief
          </button>
        </div>
      </DashboardNav>

      <main className="flex-1 relative overflow-y-auto bg-gray-100 focus:outline-hidden">
        <div className="px-4 mt-6 sm:px-6 lg:px-8">
          <ul className="flex flex-row flex-wrap">
            {(briefs?.items || []).map(brief => (
              <li
                key={brief.id}
                className="col-span-1 bg-white rounded-lg shadow-sm divide-y divide-gray-200 m-3 w-full sm:w-80"
              >
                {/* TODO(Jose): Cleanup homepage */}
                {/*<ReportCard report={brief} disabled={!activeAccount} />*/}
              </li>
            ))}
          </ul>
        </div>
      </main>
    </DashboardPageLayout>
  );
};

export default HomePage;
